<template>
	<el-dialog v-dialogDrag title="邀请好友" :visible.sync="show" width="620px" :before-close="close">
		<div class="add-group-member">
			<div class="left-box">
				<div class="search">
					<el-input placeholder="搜索好友" v-model="searchText" size="small" @input="onSearchInput">
						<i class="el-icon-search el-input__icon" slot="suffix"> </i>
					</el-input>
				</div>
				<el-scrollbar ref="friendScrollbar" style="height:400px;" class="friend-scroll">
					<div v-for="friend in visibleFriends" :key="friend.id">
						<friend-item :showDelete="false"
							@click.native="onSwitchCheck(friend)" :menu="false" :friend="friend" :active="false">
							<el-checkbox :disabled="friend.disabled" @click.native.stop="" class="checkbox"
								v-model="friend.isCheck" size="medium"></el-checkbox>
						</friend-item>
					</div>
					<div class="load-more" v-if="hasMore">加载中...</div>
				</el-scrollbar>
			</div>
			<div class="arrow el-icon-d-arrow-right"></div>
			<div class="right-box">
				<div class="tip"> 已勾选{{ checkCount }}位好友</div>
				<el-scrollbar style="height:400px;">
					<div v-for="friend in checkedFriends" :key="friend.id">
						<friend-item :friend="friend" :active="false"
							@del="onRemoveFriend(friend)" :menu="false">
						</friend-item>
					</div>
				</el-scrollbar>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close()">取 消</el-button>
			<el-button type="primary" @click="onOk()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import FriendItem from '../friend/FriendItem.vue';
import { inviteGroupMembers } from '../../api/legacy.js';

export default {
	name: "addGroupMember",
	components: {
		FriendItem
	},
	data() {
		return {
			show: false,
			searchText: "",
			friends: [],
			visibleCount: 300,  // 分批渲染：全量好友（8000+）一次性渲染 DOM 卡顿，滚动渐进展示
			PAGE_SIZE: 300
		}
	},
	mounted() {
		// el-scrollbar（element-ui 2.15.x）不 emit scroll 事件，需对内部 wrap 绑定原生监听
		this.$nextTick(() => {
			const wrap = this.$refs.friendScrollbar && this.$refs.friendScrollbar.$refs && this.$refs.friendScrollbar.$refs.wrap;
			if (wrap) {
				wrap.addEventListener('scroll', this.onScroll);
			}
		});
	},
	beforeDestroy() {
		const wrap = this.$refs.friendScrollbar && this.$refs.friendScrollbar.$refs && this.$refs.friendScrollbar.$refs.wrap;
		if (wrap) {
			wrap.removeEventListener('scroll', this.onScroll);
		}
	},
	methods: {
	async open() {
			this.show = true;
			this.friends = [];
			this.visibleCount = this.PAGE_SIZE;
			// 面板需要完整好友列表：分页未拉完或筛选残留（friends 被筛选结果整体替换过，
			// 可能为空）时补拉全量；补拉前必须清空筛选，并用 reset 替换而非追加，
			// 避免筛选残留数据与新列表混合
			if (this.friendStore.hasActiveFilter || !this.friendStore.loadedAll) {
				if (this.friendStore.hasActiveFilter) {
					this.friendStore.resetFilter();
				}
				try {
					await this.friendStore.loadFriend({ reset: true, pageSize: 0 });
				} catch (e) {
					console.error('[AddGroupMember] 好友全量加载失败:', e);
				}
			}
			this.friendStore.friends.forEach((f) => {
				if (f.deleted) {
					return;
				}
				let friend = JSON.parse(JSON.stringify(f))
				let m = this.members.filter((m) => !m.quit)
					.find((m) => m.userId == f.id);
				if (m) {
					// 好友已经在群里
					friend.disabled = true;
					friend.isCheck = true
				} else {
					friend.disabled = false;
					friend.isCheck = false;
				}
				this.friends.push(friend);
			})
		},
		// 搜索输入：本地过滤（数据已在内存），重置分批计数
		onSearchInput() {
			this.visibleCount = this.PAGE_SIZE;
		},
		// 滚动接近底部时扩大渲染范围（分批渲染，无网络请求）
		onScroll(e) {
			const el = e.target || e.srcElement;
			if (!el) return;
			const dist = el.scrollHeight - el.scrollTop - el.clientHeight;
			if (dist < 100) {
				this.visibleCount += this.PAGE_SIZE;
			}
		},
		close() {
			this.show = false;
		},
		onOk() {
			let inviteVO = {
				groupId: this.groupId,
				friendIds: []
			}
			this.friends.forEach((f) => {
				if (f.isCheck && !f.disabled) {
					inviteVO.friendIds.push(f.id);
				}
			})
			if (inviteVO.friendIds.length > 0) {
				inviteGroupMembers(inviteVO).then(() => {
					this.$message.success("邀请成功");
					this.$emit("reload");
					this.close()
				})
			}
		},
		onRemoveFriend(friend) {
			friend.isCheck = false;
		},
		onSwitchCheck(friend) {
			if (!friend.disabled) {
				friend.isCheck = !friend.isCheck
			}
		}
	},
	props: {
		groupId: {
			type: Number
		},
		members: {
			type: Array
		}
	},
	computed: {
		// 本地搜索过滤（字段与 friendStore 数据一致：nickname）
		filteredFriends() {
			const kw = this.searchText ? this.searchText.trim().toLowerCase() : '';
			if (!kw) return this.friends;
			return this.friends.filter(f =>
				(f.nickname || '').toLowerCase().includes(kw) ||
				(f.userID || '').toLowerCase().includes(kw));
		},
		// 分批渲染：只渲染前 visibleCount 条，滚动渐进扩大
		visibleFriends() {
			return this.filteredFriends.slice(0, this.visibleCount);
		},
		hasMore() {
			return this.visibleCount < this.filteredFriends.length;
		},
		// 已勾选列表（右栏）：computed 过滤避免模板全量遍历 + v-if
		checkedFriends() {
			return this.friends.filter(f => f.isCheck && !f.disabled);
		},
		checkCount() {
			return this.checkedFriends.length;
		}
	}
}
</script>

<style lang="scss" scoped>
.add-group-member {
	display: flex;

	.left-box {
		flex: 1;
		overflow: hidden;
		border: var(--im-border);

		.search {
			height: 40px;
			display: flex;
			align-items: center;

			.el-input__inner {
				border: unset;
				border-bottom: var(--im-border);
			}
		}

		.checkbox {
			margin-right: 20px;
		}

		.load-more {
			padding: 10px 0;
			text-align: center;
			font-size: 12px;
			color: var(--im-text-color-light);
		}
	}

	.arrow {
		display: flex;
		align-items: center;
		font-size: 18px;
		padding: 10px;
		font-weight: 600;
		color: var(--im-color-primary);
	}

	.right-box {
		flex: 1;
		border: var(--im-border);

		.tip {
			text-align: left;
			height: 40px;
			line-height: 40px;
			text-indent: 10px;
			color: var(--im-text-color-light)
		}
	}
}
</style>